export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      '&.MuiInputBase-root.Mui-disabled fieldset': {
        borderStyle: 'dotted',
      },
      '&.MuiInputBase-root': {
        width: '100%',
        background: 'var(--primary-contrast)',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: '12px',
      },
      "input[type='search' i]::-webkit-search-cancel-button ": {
        display: 'none',
      },
    },
  },
}
